<!--
 * @Author: 熊燕萍
 * @Date: 2022-01-08 16:35:30
 * @LastEditors: 方宾菲
 * @LastEditTime: 2025-04-25 09:47:32
 * @Description: 开始时间-结束时间日期控件
 * @FilePath: \ys.gnss\src\components\common\YsDaterangePicker.vue
-->
<template>
  <div class="ys-date-picker">
    <el-date-picker
      v-model="value1"
      :type="type"
      placeholder="开始日期"
      :picker-options="pickerOptions1"
      :size="size"
      :format="valueFormat"
      :value-format="valueFormat"
      :style="{ width: width }"
      :clearable="clearable"
    >
    </el-date-picker>
    -
    <el-date-picker
      v-model="value2"
      :type="type"
      placeholder="结束日期"
      :picker-options="pickerOptions2"
      :size="size"
      :format="valueFormat"
      :value-format="valueFormat"
      :style="{ width: width }"
      :clearable="clearable"
    >
    </el-date-picker>
  </div>
</template>

<script>
export default {
  props: {
    //输入框尺寸
    size: {
      type: String,
      default: "small",
    },
    //日期类型传date、日期时间类型传datetime,默认日期类型
    type: {
      type: String,
      default: "date",
    },
    //值的格式，yyyy-MM-dd或者yyyy-MM-dd HH:mm:ss
    valueFormat: {
      type: String,
      default: "yyyy-MM-dd",
    },
    //单个日期控件的宽度
    width: {
      type: String,
      default: "200px",
    },
    //是否允许开始时间小于当前时间,默认允许为true，不允许为false
    stimeLtCurTime: {
      type: Boolean,
      default: true,
    },
    //是否允许结束时间小于当前时间,默认不允许为false，允许为true
    etimeLtCurTime: {
      type: Boolean,
      default: false,
    },
    dataVal: {
      type: Array,
      default: () => {
        return [];
      },
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  model: {
    prop: "dataVal",
    event: "change",
  },
  data() {
    return {
      value1: "",
      value2: "",
      pickerOptions1: {
        disabledDate: (time) => {
          if (this.value2) {
            if (this.stimeLtCurTime) {
              return time.getTime() > new Date(this.value2);
            } else {
              //开始日期不能大于当前日期
              return (
                time.getTime() > new Date(this.value2) ||
                time.getTime() < Date.now() - 8.64e7
              );
            }
          } else {
            if (this.stimeLtCurTime == false) {
              return time.getTime() < Date.now() - 8.64e7;
            }
          }
        },
      },
      pickerOptions2: {
        disabledDate: (time) => {
          if (this.value1) {
            if (this.etimeLtCurTime) {
              //结束日期不能大于当前日期
              return (
                time.getTime() < new Date(this.value1) ||
                time.getTime() < Date.now() - 8.64e7
              );
            } else {
              return time.getTime() < new Date(this.value1);
            }
          } else {
            if (this.etimeLtCurTime == true) {
              return time.getTime() < Date.now() - 8.64e7;
            }
          }
          // if (this.value1) {
          //   return (
          //     time.getTime() < new Date(this.value1.substring(0, 10) + " 00:00")
          //   );
          // }
        },
      },
    };
  },
  watch: {
    dataVal(val) {
      if (val.length == 2) {
        this.value1 = val[0];
        this.value2 = val[1];
      } else {
        this.value1 = "";
        this.value2 = "";
      }
    },
    value1(val) {
      this.$emit("change", [val, this.value2]);
    },
    value2(val) {
      this.$emit("change", [this.value1, val]);
    },
  },
  mounted() {
    if (this.dataVal.length == 2) {
      this.value1 = this.dataVal[0];
      this.value2 = this.dataVal[1];
    }
  },
};
</script>

<style scoped>
.ys-date-picker {
  display: inline-block;
}
</style>
